var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgMinusCheckbox = function SvgMinusCheckbox(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9E2",
    fillRule: "evenodd",
    d: "M4.111 1h7.778A3.11 3.11 0 0 1 15 4.111v7.778A3.11 3.11 0 0 1 11.889 15H4.11A3.11 3.11 0 0 1 1 11.889V4.11A3.11 3.11 0 0 1 4.111 1M5.8 7.5a.8.8 0 1 0 0 1.6h4.4a.8.8 0 0 0 0-1.6z",
    clipRule: "evenodd"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgMinusCheckbox);
export { ForwardRef as ReactComponent };